export const meaningSynonyms = (meaning, synonymOverride) => {
  const synonyms = meaning?.synonyms || [];
  return synonymOverride
    ? [synonymOverride, ...synonyms.filter(synonym => String(synonym.id) !== String(synonymOverride.id))]
    : synonyms;
};

export const meaningSynonymText = (synonyms, expanded, dictionarySentences) => {
  const truncate = !expanded || dictionarySentences;
  const displayed = truncate ? synonyms.slice(0, 2) : synonyms;
  const text = displayed.map(synonym => synonym.targetTextWithDefiniteArticle || synonym.targetText).join(', ');
  return `${text}${truncate && synonyms.length > 2 ? '…' : ''}`;
};

export const meaningDetailSources = (translationSources, synonyms, languageId, onPress) =>
  translationSources.concat(synonyms.map(synonym => ({
    id: `synonym-${synonym.id}`,
    onPress: () => onPress(synonym),
    source: {
      languageId,
      textForUser: () => synonym.targetTextWithDefiniteArticle || synonym.targetText,
    },
  })));
